var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopicPronombres(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E2E8F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "peopleGrad1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#475569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#334155"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "peopleGrad2",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#64748B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#475569"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "url(#bgGrad)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(32, 34)",
    filter: "drop-shadow(0px 3px 2px rgba(51, 65, 85, 0.2))"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10, 4) scale(0.85)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -10,
    r: 6,
    fill: "url(#peopleGrad2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -10,2 C -10,-4 -6,-5 0,-5 C 6,-5 10,-4 10,2 L 10,12 L -10,12 Z",
    fill: "url(#peopleGrad2)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10, 4) scale(0.85)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -10,
    r: 6,
    fill: "url(#peopleGrad2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -10,2 C -10,-4 -6,-5 0,-5 C 6,-5 10,-4 10,2 L 10,12 L -10,12 Z",
    fill: "url(#peopleGrad2)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -12,
    r: 7,
    fill: "url(#peopleGrad1)",
    stroke: "#F8FAFC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -11,2 C -11,-4 -6,-6 0,-6 C 6,-6 11,-4 11,2 L 11,14 L -11,14 Z",
    fill: "url(#peopleGrad1)",
    stroke: "#F8FAFC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -2,-6 L 0,-2 L 2,-6",
    fill: "none",
    stroke: "#F8FAFC",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicPronombres);
export default __webpack_public_path__ + "static/media/topic_pronombres.cbf75b517bf302702d611a0bd347caeb.svg";
export { ForwardRef as ReactComponent };